/* eslint-disable */
const LangUnregister = {
	"unregister._title": ["REMOVE MY ACCOUNT", "លុប​គណនី​​​ខ្ញុំ"],
	"unregister._content": [
		`<p>
			By unregister your Card, you will no longer
			be a member of Starbucks Rewards<sup>TM</sup>.
			You will be forfeiting any of the
			Stars or available rewards. Your account
			information will be removed.
		</p>`,
		`<p>
		ប្រសិន​បើ​លុប​កាត​​ចោល លោក​អ្នក​នឹង​បាត់បង់​សិទ្ធិ​ជា​សមាជិក​របស់​ Starbucks Rewards<sup>TM</sup> ។ លោក​អ្នក​នឹង​បាត់បង់​ចំនួន​ផ្កាយ​ និង​រង្វាន់​ដែល​​បាន​សន្សំ​ទាំង​អស់ ។​
		ព័ត៌មាន​លម្អិត​ពី​គណនី​របស់​លោក​អ្នក​ នឹង​ត្រូវ​បាន​លុប​ចោល​ផង​ដែរ​ ។
		</p>`,
	],
	"unregister._removeButton": ["Remove My Account", "លុប​គណនី​​ខ្ញុំ"],
	"unregister.message._hasStoreBalance": [
		"You cards still have balance. Please use it  before unregistering.",
		"កាត​របស់​លោក​អ្នក​នៅ​មាន​ទឹក​ប្រាក់​​ ។​ សូម​ប្រើ​ឲ្យ​អស់ មុន​នឹង​លុប​ចោល ។​​",
	],
	"unregister.message._confirmation": [
		"Are you sure you want to unregister?",
		"តើ​លោក​អ្នក​ពិត​ជា​ចង់​លុប​ចោល​មែន​?",
	],
	"unregister.message._confirmation_": [
		"Dear ${MyName}" +
			`<br>` +
			"To complete this process, please check your email to confirm your account has been unregistered. This will ensure your account is removed from our system.",
		"ជូនចំពោះ ${MyName}" +
			`<br>` +
			"ដើម្បី​​បញ្ចប់​ដំណើរការ​នេះ​​ សូម​ឆែក​អ៊ីម៉ែល​របស់​លោក​អ្នក​ដើម្បី​ឲ្យ​ប្រាកដ​ថា​គណនី​របស់​លោក​អ្នក​ ត្រូវ​បាន​លុប​ចោល និង​ធានា​ថា​​ព័ត៌មាន​ទាំង​អស់​ត្រូវ​បាន​លុប​ចេញ​ពី​ទិន្នន័យ​របស់​យើង​ខ្ញុំ ។",
	],
}

export default LangUnregister



// WEBPACK FOOTER //
// ./src/resources/pages/LangUnregister.js